import React, { useEffect } from 'react';
import clsx from 'clsx';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Copyright from '../../app/Copyright';
import { Button, Avatar, Menu, MenuItem, Modal } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import UserMain from './components/UserMain';
import UserRainfallLogs from './components/UserRainfallLogs';
import { useAuth } from '../../contexts/AuthContext';
import { useHistory, useParams } from 'react-router-dom';
import { PageParams } from '../../types/Types';
import Profile from '../auth/profile/Profile';
import UserPageStyles from './UserPageStyles';
import { useData } from '../../contexts/DataContext';
import UserRainGauges from './components/UserRainGauges';
import UserRiverScales from './components/UserRiverScales';
import UserRiverLevelLogs from './components/UserRiverLevelLogs';

const UserPage: React.FC = () => {
    const classes = UserPageStyles();
    const auth = useAuth();
    const data = useData();
    const history = useHistory();

    /* Avtar menu handlers */
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    /* Sign out handler*/
    const handleSignOut = async () => {
        try {
            await auth?.logout();
            history.push("/signin");
        } catch (error) {
            console.error(error);
        }
    }

    /*Profile update modal handlers*/
    const [modalOpen, setModalOpen] = React.useState(false);

    const handleModalOpen = () => {
        setModalOpen(true);
        handleClose();
    };

    const handleModalClose = () => setModalOpen(!auth?.currentUser?.displayName)

    /* Component selector */
    let { page } = useParams<PageParams>();
    const renderSwitch = (param: string) => {
        switch (param) {
            case 'rainfall':
                return <UserRainfallLogs />;
            case 'riverlevel':
                return <UserRiverLevelLogs />;
            case 'raingauge':
                return <UserRainGauges />;
            case 'riverscale':
                return <UserRiverScales />;
            default:
                return <UserMain />;
        }
    }

    useEffect(() => {
        data?.refreshRainfallData();
        setModalOpen(!auth?.currentUser?.displayName)
        // eslint-disable-next-line
    }, [])

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="absolute" className={clsx(classes.appBar)}>
                <Toolbar className={classes.toolbar}>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title} onClick={() => history.push("/u")}>
                        {!page ?
                            "MRRM"
                            : <ArrowBack />
                        }
                    </Typography>
                    <Button onClick={handleClick}>
                        <Avatar>{auth?.currentUser?.displayName?.charAt(0)}</Avatar>
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleModalOpen}>Profile</MenuItem>
                        <MenuItem onClick={handleSignOut}>Logout</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={page ? classes.containerZeroPadding : classes.container}>
                    {auth?.currentUserRole ? renderSwitch(page) : <h3>You are not authorised yet. Please try after sometime.</h3>}
                    <Box pt={4}>
                        <Copyright />
                    </Box>
                </Container>
            </main>
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div><Profile /></div>
            </Modal>
        </div >
    );
}
export default UserPage